let menus = [
  {
    name: 'dashboard',
    label: 'Giriş',
    icon: 'ti-dashboard',
    path: '/',
    roles: ['ALL']
  },
];

// import customerBundle from '../BundleCustomers'
// import antennaBundle from '../BundleAntennas'
// import packageBundle from '../BundlePackage'

//
// menus = menus.concat(customerBundle.menus);
// menus = menus.concat(antennaBundle.menus);
// menus = menus.concat(packageBundle.menus);

import applicationBundle from '../BundleApplication'
menus = menus.concat(applicationBundle.menus);

let components = [];
// components = components.concat(antennaBundle.menuComponents);
// components = components.concat(packageBundle.menuComponents);


export default {
  menu: menus,
  components: components
}



// WEBPACK FOOTER //
// ./src/resources/menu.js